<template>
  <div
    class="tender-members-info"
    :class="{'is-small': mini}">
    <div
      class="nav-bar-btn"
      :class="{'show-navBar': !mini}"
      data-qa="btn-collapse-navBar"
      @click="changeNavbarState(!mini)">
      <sIcon
        class="my-auto mx-auto"
        :rotate="mini ? 0 : 180"
        size="10"
        type="double-arrow"/>
    </div>
    <div
      class="tender-members-info-title"/>
    <sIcon
      v-if="!mini && loading"
      class="mx-auto"
      color="var(--secondary__green_not_active)"
      size="30"
      spin
      type="loading"/>
    <div
      v-else-if="!mini && !invitedCount"
      class="px-4">
      <div class="pt-2 pl-2 pr-1 flex wrap h4-headline align-center">
        {{ $t('Tenders.NoAnyParticipants') }}
      </div>
      <div class="mt-3 pl-2 h6-text text-start">
        {{ $t('Tenders.NoAnyParticipantsText') }}
      </div>
    </div>
    <div
      v-if="mini || invitedCount">
      <div
        :class="mini ? 'pt-4 flex' : 'py-2 h4-headline flex pl-2 pr-1 wrap'">
        <template v-if="!mini">
          {{ $t('Tenders.Invited') }}
        </template>
        <sChip
          :background="invitedCount ? 'var(--color-success)' : 'var(--color-disabled)'"
          :class="mini ? 'mx-auto' : 'ml-2 my-auto'"
          color="black"
          :text="invitedCount"/>
        <sButton
          v-if="!mini"
          class="btn h11-links-bold ml-auto"
          :disabled="!invitedCount || add_invited"
          icon="delete"
          small
          type="text"
          @click="deleteAll">
          {{ $t('Common.Clear') }}
        </sButton>
      </div>
    </div>
    <template v-if="invitedCount">
      <div
        v-if="mini"
        class="flex flex-wrap">
        <sTooltip
          :content="$t('Tenders.AllSubscribers')">
          <sChip
            background="var(--color-disabled)"
            class="mx-auto mt-6"
            color="black"
            :text="subscribedCount"/>
        </sTooltip>
        <sTooltip
          v-for="invitedParticipant in invitedParticipants"
          :key="invitedParticipant.email">
          <div class="flex mt-6 width-100">
            <sIcon
              class="mx-auto"
              type="person"/>
          </div>
          <div
            slot="content">
            <b>{{ invitedParticipant.userName || invitedParticipant.email || '-' }}</b>
            <div
              v-if="invitedParticipant.email && invitedParticipant.userName && invitedParticipant.userName != invitedParticipant.email"
              class="item-email h8-text">
              {{ invitedParticipant.email }}
            </div>
          </div>
        </sTooltip>
      </div>
      <CartList
        v-else
        key-field="email"
        :list="invitedParticipants">
        <template #item-title="{ item }">
          <template 
            v-if="item.organizationTitle">
            <TooltipedText
              v-if="item.organizationTitle"
              :line-count="1"
              :value="item.organizationTitle"/>
            <sDivider
              class="my-2"/>
          </template>
          {{ item.userName || '-' }}
        </template>
        <template #item-additional="{ item }">
          <div
            v-if="item.email"
            class="item-email h8-text">
            {{ item.email }}
          </div>
          <ParticipantChip
            v-if="item.manualAdded"
            custom_class="mr-2 my-2 "
            :item="item"
            manual-added/>
          <ParticipantChip
            v-if="!item.organizationId && !item.organizationUsreou"
            custom_class="mr-2 "
            unregistred/>
          <ParticipantChip
            v-if="item.isSubscribed"
            custom_class="my-2 "
            is-subscribed/>
        </template>
        <template
          v-if="tender.biddingType && (tender.biddingType.showSubscribedUsers || tender.biddingType.isPublic)"
          #prepend>
          <div
            class="list-item secondary__green_chosen rounded-lg pa-0 mb-2">
            <SubscribedToCategory
              :subscribed-to-category="subscribedToCategory"
              :tender="tender"/>
          </div>
        </template>
        <template #item-action="{ item }">
          <sButton
            :disabled="add_invited"
            icon="delete"
            small
            type="green"
            @click="deleteCard(item)"/>
        </template>
      </CartList>
    </template>
  </div>
</template>
<script>
import editTenderMixin from 'mixins/editTenderMixin.js'
import CartList from 'components/common/blocks/CartList.vue'
import editTenderMembersMixin from 'mixins/editTenderMembersMixin.js'
import ParticipantChip from 'components/common/elements/ParticipantChip.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import SubscribedToCategory from 'components/tenders/dialogs/SubscribedToCategory.vue'

import { storageMixin } from 'mixins'
import displaySize from 'mixins/display-size'

export default {
  name: 'TenderMembersInfo',
  mixins: [storageMixin, displaySize, editTenderMixin, editTenderMembersMixin],
  data() {
    return {
    }
  },
  methods: {
    changeNavbarState(result) {
      this.$emit('update:mini', result)
      this.$_savePropToDBStorage('layoutNavbarMini', this.mini)
    },
    deleteCard(item) {
      let result = this.$_.cloneDeep(this.invitedParticipants)
      const itemIndex = result.findIndex(i => i.email === item.email)

      if (itemIndex !== -1 ) {
        result.splice(itemIndex, 1)
        this.mixin_setInvited(result)
      }
    },
    deleteAll() {
      this.mixin_setInvited([])
    },
  },
  computed: {
    subscribedCount() {
      return this.subscribedToCategory?.map(i => i.users)?.flat(1)?.length || 0
    },
    /*cardListItems() {
      return this.mixin_getUnicByEmail(this.invited) || []
    },*/
    invitedCount: {
      get() {
        if (this.tender?.biddingType?.isPublic) {
          return /*(this.invited?.length || 0) + */(this.subscribersUsers?.length || 0) + (this.invitedParticipants?.length || 0)
        }
        return /*this.invited?.length + */(this.invitedParticipants?.length || 0)
      }
    },
  },
  components: {
    CartList,
    TooltipedText,
    ParticipantChip,
    SubscribedToCategory,
  },
  mounted() {
    if (this.breakpoint.smAndDown) {
      this.changeNavbarState(true)
    } else {
      this.$_getPropFromDBStorage('layoutNavbarMini', false)
        .then((result) => {
          this.changeNavbarState(result || result === 'true')
        })
    }
  },
  props: {
    mini: Boolean,
    loading: Boolean,
    tender: Object
  },
}
</script>
<style scoped lang="scss">
.nav-bar-btn {
  position: absolute;
  right: 40px;
  top: 10px;
  z-index: 10;
  background: var(--v-secondary__green_chosen-base);
  width: 30px;
  height: 30px;
  line-height: 1;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  transition: all 0.25s;
  border: 2px solid var(--v-main__green-base) !important;
  &.show-navBar {
    right: 325px;
  }
}
.tender-members-info {
  transition: all 0.25s;
  padding-right: 14px;
  text-align: left;
  width: 340px;
  background: var(--v-main__light_green-base);
  &.is-small {
    width: 40px;
    padding-right: 0px;
  }
  &-title {
    height: 44px;
    padding: 6px 0 5px;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    border-bottom: 1px solid var(--main__green_locked);
  }
}
</style>
